export const driveNYCerfificate = "https://drive.google.com/file/d/1l34I9tbhT1jsigCtUIPSGLzqMEMcGvU8/view"

export const driveCACertificate = "https://drive.google.com/file/d/1GbnRGUMDCd6OTTPfLNZ1oGEkBJmzvyCM/view"